if (!customElements.get('drop-countdown-timer')) {
  customElements.define(
    'drop-countdown-timer',
    class DropCountdownTimer extends HTMLElement {
      connectedCallback() {
        this.valueEl = this.querySelector('.drop-countdown__value');
        this.expiredText = this.dataset.expiredText || 'DROP CLOSED';
        this.sectionId = this.dataset.sectionId;

        // Prefer the server-computed epoch timestamp (works for both metafield
        // datetimes and typed dates); fall back to parsing the raw string.
        var ts = parseInt(this.dataset.endTimestamp, 10);
        if (ts && !isNaN(ts)) {
          this.endDate = new Date(ts * 1000);
        } else {
          this.endDate = new Date((this.dataset.endDate || '').replace(' ', 'T'));
        }

        if (isNaN(this.endDate.getTime())) {
          this.remove();
          return;
        }

        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        if (this.interval) clearInterval(this.interval);
      }

      tick() {
        const diff = this.endDate.getTime() - Date.now();

        if (diff <= 0) {
          this.handleExpiry();
          return;
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);

        const label = `${String(days).padStart(2, '0')}d : ${String(hours).padStart(2, '0')}h : ${String(minutes).padStart(2, '0')}m`;
        this.valueEl.textContent = label;
      }

      handleExpiry() {
        clearInterval(this.interval);

        const badge = document.createElement('span');
        badge.className = 'badge drop-countdown__closed-badge';
        badge.textContent = this.expiredText;
        this.replaceWith(badge);

        if (!this.sectionId) return;

        const submitButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (submitButton) {
          submitButton.disabled = true;
          const label = submitButton.querySelector('span');
          if (label) label.textContent = 'DROP CLOSED';
        }

        const dynamicCheckout = document.querySelector(
          `#MainProduct-${this.sectionId} .shopify-payment-button`
        );
        if (dynamicCheckout) dynamicCheckout.style.display = 'none';
      }
    }
  );
}
